import React, { useEffect, useState } from "react";
import { Typography, Button, Checkbox, IconButton, Badge } from "@mui/material";
import Image from "assets/img/default-img.jpg";
import Box from "@mui/material/Box";
import Card from "components/ui/Card";
import { useGlobalContext } from "context/GlobalContext";
import { getIcon } from "utils/iconsConfig";
import ViewDetails from "./ViewDetails/ViewDetails";
import ImageModal from "./ImageModal";
import Tooltip from "./Tooltip";
import BestSellerModal from "./BestSellerModal/BestSellerModal";
import SaleDetailsModal from "./SaleDetailsModal/SaleDetailsModal";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificMenu, findSpecificPage, findSpecificSubMenu, findSpecificSubPage, hasAccessPage, hasAccessSubPage, isAllowed } from "utils/checkUserRigths";
import SmallImage from "./SmallImage";
import { formatDate } from "utils/formatDate";
import CartIcon from "components/Icons/CartIcon";

import { getProductIcon } from "../../assets/productIcon/Products";

import BinnysSelectTableModal from "features/collection/components/Modal/Binnys_select_table/BinnysSelectTableModal";
import CreateProjectDetailsModal from "./CreateModal/CreateProjectDetailsModal";
import CreateStockOrderModal, { ConsistentIcon } from "./CreateModal/CreateStockOrderModal";
import ReOrderSettingsModal from "./CreateModal/ReOrderSettinsModal";
import QuickCustomerOrder from "./CreateModal/QuickCustomerOrder";
import CreateModificationModal from "./CreateModal/CreateModificationModal";
import "./CreateModal/createmodification.css";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addEditCategory } from "store/cartSlice";
import apiClient from "lib/api-client";
import { useQueryClient } from "@tanstack/react-query";
import { Opacity } from "@mui/icons-material";

export const resolveIcon = (type, variant) => {
  if (!type) return null;

  return getProductIcon(type, variant);
};

const ProductCard = ({
  data,
  addtoCart,
  cardStyle = { borderRadius: "10px", padding: "20px" },
  btnTilte,
  isBtn,
  selectedCartProducts,
  removeCart,
  hoverEffect,
  checkedItems,
  handleCheckboxChange,
  variant = "default",
  presentInCatalog,
  style,
  btnWidth,
  handleShowDetails,
  handleHideDetails,
  handleViewCartDetails,
  updateCatagoryData,
  allData,
  objectFit,
  imageModalAnchor,
  disableContextMenu = false,
}) => {
  const { setIsEditCatagoryData } = useGlobalContext();
  const [qty, setQty] = useState(0);
  // const [details, setDetails] = useState([]);
  const [collectionModal, setCollectionModal] = useState(false);
  const [setModal, setSetModal] = useState(false);
  const [bestSellerModal, setBestSellerModal] = useState(false);
  const [salesDetailsModal, setSaleDetailModal] = useState(false);
  const [imageModal, setImageModal] = useState({ isOpen: false, imgUrl: null, designNo: null });
  const [binnysSelectOrderModal, setBinnysSelectOrderModal] = useState(false);
  const [createModal, setCreateModal] = useState(false);
  const [createModificationModal, setCreateModificationModal] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(null);
  const [createData, setCreateData] = useState(null);
  const [createProjectBtn, setCreateProjectBtn] = useState(null);
  const [stockOrderModal, setStockOrderModal] = useState(false);
  const [reOrderModal, setReOrderModal] = useState(false);
  const [customerOrderModal, setCustomerOrderModal] = useState(false);
  const [hovered, setHovered] = useState(null);
  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === allData?.length - 1 || allData?.length === 0;
  const location = useLocation();
  const isCreateOrder = location.state?.newName === "Create Order";
  const state = location?.state;
  const isEdit = state && state?.edit ? state?.edit : false;
  const [actionType, setActionType] = useState(null);
  const queryClient = useQueryClient();
  const [isHidden, setIsHidden] = useState(!!data?.isHidden || false);
  const dispatch = useDispatch();

  const cartData = useSelector((state) => state.cart?.cartData || []);

  // console.log({btnTilte});

  //---------------- Rights Access start ---------------------\\

  const permission = usePermissions();

  // const hasAccessToSeeSales = hasAccessPage(findSpecificPage("Sales Count", permission), "view");

  const hasAccessToYearlySalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By year"), "view");
  const hasAccessToClientSalesData = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sales By Client"), "view");
  const hasAccessToSeeHighestSeller = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Highest Seller Trophy"), "view");
  const hasAccessToSeeBestSeller = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Best Seller Border"), "view");

  //const hasAccessToYearlyData = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sales Count", permission), "Sales By Year"), "view");
  // const hasAccessToPublicData = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sales Count", permission), "Sales By Client"), "view");
  // const hasAccessToSeeCreationDate = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission), "Design Date"), "view");
  const hasAccessToSeeCreationDate = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Design Date"), "view");
  // const hasAccessToSeeBestSeller = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sales Count", permission), "Best Seller Border"), "view");
  // const hasAccessToSeeHighestSeller = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Sales Count", permission), "Highest Seller Trophy"), "view");
  // const hasAccessToSeeWatermark = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Other Settings", permission, "Watermark"), "Watermark"), "view");
  const hasAccessToSeeWatermark = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Watermark"), "view") && !permission?.isAdmin;
  const hasSetsAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Sets Access"), "view");
  const hasStockAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Stocks Access"), "view");
  const hasCollectionAccess = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Collection Access"), "view");


  // Quick Acces Rights
  const hasAccessCreateProject = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Quick Access"), "create_project");
  const hasAccessCreateModification = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Quick Access"), "create_modification");
  const hasAccessCreateCustomerQuote = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Quick Access"), "create_customer_quote");
  const hasAccessCreateStockQuote = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Quick Access"), "create_stock_quote");
  const hasAccessSetReStockQuote = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Quick Access"), "set_restock_quote");
  const hasAccessHideDesign = isAllowed(findSpecificSubMenu(findSpecificMenu("Vision Web", permission), "Quick Access"), "hide_design");

  const hasQuickAccess = hasAccessCreateProject || hasAccessCreateModification || hasAccessCreateCustomerQuote || hasAccessCreateStockQuote || hasAccessSetReStockQuote || hasAccessHideDesign;


  //---------------- Rights Access End -------------------------\\

  const hasSalesAccess = hasAccessToClientSalesData || hasAccessToYearlySalesData;

  const clientFlow = location?.pathname?.includes("client-flow");

  const handleOpenImageModal = React.useCallback(
    (imgUrl, designNo) => {
      setImageModal({ isOpen: true, imgUrl, designNo });
      let newIndex = allData?.findIndex((item) => item?.styleNumber == designNo);

      setCurrentIndex(newIndex);
    },
    [allData]
  );

  const handleCloseImageModal = React.useCallback(() => {
    setImageModal((prev) => ({
      ...prev,
      isOpen: false,
    }));
    setCurrentIndex(currentIndex);

    setTimeout(() => {
      setImageModal({ isOpen: false, imgUrl: null, designNo: null });
    }, 500);
  }, []);

  //end img modal code

  const handleAddEditCatagoryData = () => {
    dispatch(
      addEditCategory({
        storageKey: updateCatagoryData,
        data: {
          _id: selectedCartProducts?._id || selectedCartProducts?.id,
          styleNumber: selectedCartProducts?.styleNumber,
        },
      })
    );
    addtoCart();
  };

  const handleBestSeller = React.useCallback(() => {
    setBestSellerModal(true);
  }, [setBestSellerModal]);

  const handleBinnysSelectOrder = React.useCallback(() => {
    setBinnysSelectOrderModal(true);
  }, [setBinnysSelectOrderModal]);

  const handleNavigate = () => {
    const newPath = `/aiStock/${data?.id || data?._id}/${data?.styleNumber}`;
    window.open(newPath, "_blank");
  };

  const handleNextClick = () => {
    if (currentIndex < allData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = allData[newIndex];

      setImageModal((prev) => ({
        ...prev,
        isOpen: true,
        imgUrl: nextItem?.imageUrl || nextItem?.images?.[0]?.imageUrl || nextItem?.Orgimg || null,
        designNo: nextItem?.styleNumber,
      }));
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = allData[newIndex];
      setImageModal((prev) => ({
        ...prev,
        isOpen: true,
        imgUrl: prevItem?.imageUrl || prevItem?.images?.[0]?.imageUrl || prevItem?.Orgimg || null,
        designNo: prevItem?.styleNumber,
      }));
    }
  };

  useEffect(() => {
    if (allData?.length && data?.styleNumber) {
      const index = allData.findIndex((item) => item?.styleNumber === data?.styleNumber);
      setCurrentIndex(index);
    }
  }, [allData]);

  const ConsistentIcon = ({ type, color }) => {
    const iconElement = getIcon(type, color);
    return React.cloneElement(iconElement, {
      style: { width: "21px", height: "21px", maxWidth: "21px", maxHeight: "21px" },
    });
  };

  const ratio = React.useMemo(() => {
    if (!data?.diamond || !data?.weight) return "NA";

    const diamondWt = parseFloat(data.diamond.split(" ")[0]);
    const netGoldWt = parseFloat(data.weight.split(" ")[0]);

    if (!diamondWt || !netGoldWt) return "NA";

    const value = (diamondWt / netGoldWt) * 100;

    return value.toFixed(2);
  }, [data?.diamond, data?.weight]);

  //showDetails.
  const showDetails = React.useMemo(
    () => [
      {
        left: [
          {
            label: data?.styleNumber
              .split("-")
              ?.map((part, i) => (i === 1 && part?.length > 5 ? part.slice(0, 5) + "..." : part))
              .join("-"),
            Icon: resolveIcon(data?.designClass, variant),
            tooltipTitle: null,
            access: true,
            styleNumber: data?.styleNumber,
          },
          { label: data?.diamond, Icon: resolveIcon("diamond", variant), tooltipTitle: "Diamond Weight / Diamond Pieces", access: true },
          { label: data?.weight, Icon: resolveIcon("goldbar", variant), tooltipTitle: "Gold Net Weight / Gold Gross Weight", access: true },
          { label: `${data?.colorStoneWeight} Ct / ${data?.colorStonePcs} Pcs`, Icon: resolveIcon("gemstone", variant), tooltipTitle: "ColorStone Weight / ColorStone Pieces", access: true },
          {
            label: `${data?.otherMaterialWeight} g / ${data?.otherMaterialPcs} Pcs`,
            Icon: resolveIcon("otherMaterial", variant),
            tooltipTitle: "OtherMaterial Weight / OtherMaterial Pieces",
            access: true,
          },

          { label: data.labour, Icon: resolveIcon("labour", variant), tooltipTitle: "Make Type" },
          {
            label: clientFlow ? `${data?.totalClientSales ?? "-"} / ${data?.sales ?? "-"}` : data?.sales,
            Icon: resolveIcon("sales", variant),
            tooltipTitle: "Sales",
            click: data?.sales > 0 && hasSalesAccess ? () => setSaleDetailModal(true) : null,
            access: hasSalesAccess,
          },
          {
            label: `${data?.itemSize ?? "N/A"}`,
            Icon: resolveIcon("scale", variant),
            tooltipTitle: "Size",
            access: true,
          },
          { label: ratio, Icon: resolveIcon("RatioIcon", variant), tooltipTitle: "Ratio", access: true },
          {
            label: data?.date,
            Icon: resolveIcon("date", variant),
            tooltipTitle: "Design Creation Date",
            access: hasAccessToSeeCreationDate,
          },
        ],
      },
      {
        middle: [
          {
            label: data?.collectionDetails && data?.collectionDetails.length > 0 ? "collectionDetails" : null,
            Icon: resolveIcon("collection", variant),
            click: () => setCollectionModal(true),
            tooltipTitle: "Collections",
            access: true,
          },
          { label: data?.setDetails && data?.setDetails.length > 0 ? "setDetails" : null, Icon: resolveIcon("set", variant), click: () => setSetModal(true), tooltipTitle: "Sets", access: true },
          {
            label: data?.cup ? "cup" : null,
            Icon: resolveIcon(data?.cup, variant),
            click: handleBestSeller,
            tooltipTitle: "Highest Seller",
            badge: data?.totalTrophy,
            access: hasAccessToSeeHighestSeller,
          },
          {
            label: data?.cadIcon ? "cadIcon" : null,
            Icon: resolveIcon(data?.cadIcon ? "cadIcon" : null, variant),
            tooltipTitle: "CAD",
            access: data?.cadIcon,
          },
          {
            label: data?.stockCount > 0 ? "stockIcon" : null,
            Icon: resolveIcon("stockCount"),
            tooltipTitle: "Stock Count",
            access: true,
            click: hasStockAccess && handleNavigate,
            badge: data?.stockCount,
          },
          { label: data?.labour, Icon: resolveIcon(data?.labour, variant), tooltipTitle: "Make Type", access: true },
          {
            label: data?.styleOrderCount > 0 ? "StyleOrderCount" : null,
            Icon: <CartIcon color="white" customWidth="17" customHeight="17" />,
            tooltipTitle: "Cart Count",
            access: true,
            badge: data?.styleOrderCount,
            click: handleBinnysSelectOrder,
          },
          {
            label: data?.reorderData ? "Reorder" : null,
            Icon: resolveIcon("reorderIcon"),
            tooltipTitle: "Reorder",
            access: true,
            // badge: data?.styleOrderCount,
            // click: handleBinnysSelectOrder,
          },
        ],
      },
    ],
    [data, variant, hasSalesAccess]
  );

  //hideDetails - This is Used For CatalogSetting.
  const hideDetails = React.useMemo(
    () => [
      {
        left: [
          { label: data?.styleNumber, Icon: resolveIcon(data?.designClass, variant), tooltipTitle: null, access: true },
          { label: data.view, Icon: resolveIcon("catalogView", variant), click: handleViewCartDetails ? () => handleViewCartDetails(data, "view") : null, tooltipTitle: null, access: true },
          { label: data.cart, Icon: resolveIcon("catalogCart", variant), click: handleViewCartDetails ? () => handleViewCartDetails(data, "cart") : null, tooltipTitle: null, access: true },
          {
            label: data.removeCart,
            Icon: resolveIcon("catalogRemoveCart", variant),
            click: handleViewCartDetails ? () => handleViewCartDetails(data, "removeCart") : null,
            tooltipTitle: null,
            access: true,
          },
          { label: data.clock, Icon: resolveIcon("catalogClock", variant), click: handleViewCartDetails ? () => handleViewCartDetails(data, "clock") : null, tooltipTitle: null, access: true },
        ],
      },
    ],
    [data, handleViewCartDetails, variant]
  );

  const toggelDetails = () => {
    if (btnTilte === "Show Details") {
      handleShowDetails();
    } else {
      handleHideDetails();
    }
  };

  //For Create Project Feature
  const handleRightClick = (event) => {
    event.preventDefault(); // stop default browser context menu
    if (disableContextMenu) return;

    setCreateProjectBtn(
      createProjectBtn === null
        ? {
            mouseX: event.clientX + 2,
            mouseY: event.clientY - 6,
          }
        : // close if already open
          null
    );
  };

  const handleCloseCreateProjectBtn = () => {
    setCreateProjectBtn(null);
  };

  const handleCloseCreateModal = () => {
    setCreateModal(false);
    setCreateProjectBtn(null);
  };

  const handleCloseCreateModificationModal = () => {
    setCreateModificationModal(false);
    // setCreateProjectBtn(null);
  };

  // const handleCreateDesign = (Design) => {
  //   console.log("Paylod ------->", Design);
  //   handleCloseCreateModal();
  // };

  //Chetan Code:-
  // useEffect(() => {
  //   if (btnTilte === "Show Details") {
  //     setDetails(hideDetails);
  //   } else {
  //     setDetails(showDetails);
  //   }
  // }, [btnTilte]);

  const details = React.useMemo(() => {
    return btnTilte === "Show Details" ? hideDetails : showDetails;
  }, [btnTilte, hideDetails, showDetails]);

  const commonStyles = {
    display: "flex",
  };

  const detailStyles = {
    flexWrap: "wrap",
    rowGap: "10px",
    columnGap: "25px",
    alignItems: "center",
  };

  const expandedStyles = {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: "0px",
    cursor: "auto",
    gap: "20px",
  };

  useEffect(() => {
    if (!data?.styleNumber) return;

    const frequency = cartData.reduce((count, item) => (item.styleNumber === data.styleNumber ? count + 1 : count), 0);
    setQty(frequency);
  }, [data?.styleNumber, selectedCartProducts, cartData]);

  return (
    <>
      <Card width="auto" height="auto" style={{ ...cardStyle, ...style, border: data?.bestSeller && hasAccessToSeeBestSeller ? "1px solid #C0C0C0" : cardStyle?.border,
          ...(isHidden && {backgroundColor: "rgba(255, 255, 255, 0.29)",Opacity:"0.5" }),
          cursor: "auto",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }} width={"100%"} onContextMenu={handleRightClick}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }} width={"100%"}>
            <Box
              sx={{
                ...commonStyles,
                ...(clientFlow && { gap: "6px !important" }),
                ...(btnTilte !== "Show Details" ? detailStyles : expandedStyles),
                width: "75%",
                ...(!hasSalesAccess &&
                  btnTilte !== "Show Details" && {
                    rowGap: clientFlow ? "14px !important" : "10px",
                  }),
              }}
            >
              {details[0]?.left?.map(
                (detail, index) =>
                  detail.access && (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        ...(detail.tooltipTitle === "Sales" && {
                          flexDirection: "row",
                          mr: "15px",
                          ...(clientFlow && { width: "100%" }),
                        }),
                        ...(detail.tooltipTitle === "Sales" && {
                          ...(clientFlow && { width: "100%" }),
                        }),
                        // ...(detail.tooltipTitle === "Size" && {
                        //   ...(clientFlow && { width: "100%" }),
                        // }),
                        ...(detail.tooltipTitle === "Ratio" && {
                          ...{ width: "100%" },
                        }),
                        // ...(detail.tooltipTitle === "Sales" && {
                        //   ...{ width: "100%" },
                        // }),
                        ...(detail.tooltipTitle === "OtherMaterial Weight / OtherMaterial Pieces" && { width: "100%" }),
                        // ...(detail.tooltipTitle === "Size" && {
                        //   ...{ width: "100%" },
                        // }),
                      }}
                    >
                      {detail.click ? (
                        <IconButton disableFocusRipple disableRipple sx={{ p: 0 }} onClick={detail.click}>
                          {detail.Icon}
                        </IconButton>
                      ) : (
                        detail.Icon
                      )}
                      <Tooltip title={detail?.tooltipTitle} marginTop="2px">
                        <Typography className={`content-typo content-typo-${index}`} ml={1}>
                          {detail.label}
                        </Typography>
                      </Tooltip>
                    </Box>
                  )
              )}
              {hasSalesAccess && <SaleDetailsModal open={salesDetailsModal} setOpen={setSaleDetailModal} styleNumber={`${details[0]?.left[0]?.styleNumber}`} type="Design" />}
            </Box>
            <Box className="middle">
              {details[1]?.middle?.map(
                (detail, index) =>
                  detail?.label && (
                    <React.Fragment key={index}>
                      <Tooltip title={detail?.tooltipTitle} marginTop="4px">
                        {detail?.access && (
                          <Box className={`content-new content-new-${index}`}>
                            {detail.click ? (
                              <IconButton disableRipple disableFocusRipple sx={{ p: 0 }} onClick={detail.click}>
                                <Badge
                                  badgeContent={detail?.badge > 1 ? detail?.badge : null}
                                  sx={{
                                    "& .MuiBadge-badge": {
                                      backgroundColor: "white",
                                      color: "black",
                                      width: "10.3448px",
                                      height: "10.3448px",
                                      borderRadius: "6.17px",
                                      top: "3px",
                                      fontSize: "8px",
                                      padding: "6px",
                                      minWidth: "unset",
                                    },
                                  }}
                                >
                                  {detail.Icon}
                                </Badge>
                              </IconButton>
                            ) : (
                              detail.Icon
                            )}
                          </Box>
                        )}
                      </Tooltip>
                      {detail.label === "collectionDetails" && (
                        <ViewDetails
                          open={collectionModal}
                          setOpen={setCollectionModal}
                          list={data?.collectionDetails?.map((item) => ({
                            _id: item._id,
                            name: item.collectionName,
                          }))}
                          heading={`${details[0]?.left[0]?.label} Collection`}
                          imgUrl={data.Orgimg}
                          btnName="View Collection"
                          needMargin={true}
                        />
                      )}
                      {detail.label === "setDetails" && (
                        <ViewDetails
                          open={setModal}
                          setOpen={setSetModal}
                          list={data?.setDetails?.map((item) => ({
                            _id: item._id,
                            name: `SET - ${item.setNumber}`,
                            imgUrl: data.Orgimg ? data.Orgimg : Image,
                            styleNumber: data["styleNumber"],
                            numOfStyles: item.numOfStyles,
                          }))}
                          heading={`${details[0]?.left[0]?.label} Set`}
                          btnName="View Set"
                        />
                      )}
                      {detail.label === "cup" && <BestSellerModal open={bestSellerModal} setOpen={setBestSellerModal} styleNumber={`${data?.styleNumber}`} type="Design" />}
                    </React.Fragment>
                  )
              )}
            </Box>
          </Box>
          <Box className={`left ${clientFlow && hoverEffect ? "hover-enabled" : ""}`} sx={{ width: "200px", ...(clientFlow && { height: "204px" }), position: "relative" }}>
            <SmallImage data={data} isBtn={isBtn} handleOpenImageModal={handleOpenImageModal} hasAccessToSeeWatermark={hasAccessToSeeWatermark} objectFit={objectFit} />
            {/* <img src={data.img ? data.img : Image} loading="lazy" alt="designImg" style={{ height: isBtn ? "90%" : "100%", borderRadius: "5px" }} onClick={() => handleOpenImageModal(Image, name)} /> */}

            {data?.restrictIcon && (
              <Tooltip title={formatDate(data?.restrictDate)} marginTop="-2px">
                <Box
                  sx={{
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    zIndex: 2,
                  }}
                >
                  {data.restrictIcon === "autoRestrictedIcon" ? getIcon("autorestricted") : getIcon("manualrestricted")}
                </Box>
              </Tooltip>
            )}

            {isBtn && !hoverEffect ? (
              isCreateOrder ? (
                qty === 0 ? (
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: btnTilte === "Add" ? "#FFFFFF" : "#50C878",
                      color: btnTilte === "Add" ? "#50C878 !important" : btnTilte === "Remove" ? "#E77B7B !important" : "#ffffff !important",
                      border: btnTilte === "Remove" ? "1px solid #E77B7B" : btnTilte === "Add" ? "1px solid #50C878" : "none",
                      "&:hover": {
                        backgroundColor: btnTilte === "Add" || btnTilte === "Remove" ? "#FFFFFF" : "#50C878",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#FFFFFF !important",
                        color: "#444444 !important",
                        border: "1px solid #444444 !important",
                      },
                      width: btnWidth ? btnWidth : "110px !important",
                      height: "40px !important",
                      padding: "0px 20px !important",
                      boxShadow: "0",
                      fontFamily: "poppins",
                    }}
                    onClick={() => {
                      addtoCart(selectedCartProducts);
                      setQty(1);
                    }}
                  >
                    Add
                  </Button>
                ) : (
                  <Box
                    className="box"
                    variant="contained"
                    sx={{
                      height: "40px",
                      width: "90%",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <div
                      className="plus-icon"
                      onClick={() => {
                        if (qty > 1) {
                          setQty(qty - 1);
                          removeCart(selectedCartProducts);
                        } else {
                          setQty(0);
                          removeCart(selectedCartProducts);
                        }
                      }}
                    >
                      -
                    </div>
                    <span className="quatity-text" style={{ backgroundColor: qty > 0 ? "#50C878" : "#ffffff", color: qty > 0 ? "#ffffff" : "#50C878" }}>
                      {qty}
                    </span>
                    <div
                      className="plus-icon"
                      onClick={() => {
                        setQty(qty + 1);
                        addtoCart(selectedCartProducts);
                      }}
                    >
                      +
                    </div>
                  </Box>
                )
              ) : (
                <Button
                  variant="contained"
                  disabled={presentInCatalog ? presentInCatalog : false}
                  sx={{
                    backgroundColor: btnTilte === "Add" || btnTilte === "Remove" || btnTilte === "Show Details" || btnTilte === "Hide Details" || btnTilte === "Select" ? "#FFFFFF" : "#50C878",
                    color:
                      btnTilte === "Add" || btnTilte === "Show Details" || btnTilte === "Select"
                        ? "#50C878 !important"
                        : btnTilte === "Remove" || btnTilte === "Hide Details"
                          ? "#E77B7B !important"
                          : "#ffffff !important",
                    border:
                      btnTilte === "Remove" || btnTilte === "Hide Details"
                        ? "1px solid #E77B7B"
                        : btnTilte === "Add" || btnTilte === "Show Details" || btnTilte === "Select"
                          ? "1px solid #50C878"
                          : "none",
                    "&:hover": {
                      backgroundColor: btnTilte === "Add" || btnTilte === "Remove" || btnTilte === "Show Details" || btnTilte === "Hide Details" || btnTilte === "Select" ? "#FFFFFF" : "#50C878",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#FFFFFF !important",
                      color: "#444444 !important",
                      border: "1px solid #444444 !important",
                    },
                    width: btnWidth ? btnWidth : "110px !important",
                    height: "40px !important",
                    padding: "0px 20px !important",
                    boxShadow: "0",
                    fontFamily: "poppins",
                  }}
                  onClick={
                    btnTilte === "Add"
                      ? () => addtoCart(selectedCartProducts)
                      : btnTilte === "Select"
                        ? handleAddEditCatagoryData
                        : btnTilte === "Show Details" || btnTilte === "Hide Details"
                          ? toggelDetails
                          : // : updateCatagoryData
                            () => removeCart(selectedCartProducts)
                    // : handleRemoveCart
                  }
                >
                  {btnTilte ? btnTilte : "Add"}
                </Button>
              )
            ) : isEdit ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: checkedItems.includes(data.id) ? "#50C878" : "#FFFFFF",
                  color: checkedItems.includes(data.id) ? "#ffffff !important" : "#50C878 !important",
                  border: checkedItems.includes(data.id) ? "none" : "1px solid #50C878",
                  "&:hover": {
                    backgroundColor: checkedItems.includes(data.id) ? "#50C878" : "#FFFFFF",
                  },
                  "&.Mui-disabled": {
                    backgroundColor: "#FFFFFF !important",
                    color: "#444444 !important",
                    border: "1px solid #444444 !important",
                  },
                  width: btnWidth ? btnWidth : "110px !important",
                  position: "relative",
                  bottom: "-12px !important",
                  height: "40px !important",
                  padding: "0px 20px !important",
                  boxShadow: "0",
                  fontFamily: "poppins",
                }}
                onClick={() =>
                  handleCheckboxChange(data.id)({
                    target: { checked: !checkedItems.includes(data.id) },
                  })
                }
              >
                {checkedItems.includes(data.id) ? "Selected" : "Select"}
              </Button>
            ) : (
              ""
            )}

            {/* {hoverEffect && <input type="checkbox" className="hoverCheck" onChange={handleCheckboxChange(data.id)} checked={checkedItems.includes(data.id)} />} */}
          </Box>

          {createProjectBtn !== null && hasQuickAccess && (
            <div
              style={{
                position: "fixed",
                inset: 0,
                zIndex: 999,
              }}
              onClick={() => {
                setCreateProjectBtn(null);
                setHovered(null);
              }} //to close btn click anywhere
            >
              <div className="createmodify-menu " style={{ top: createProjectBtn.mouseY, left: createProjectBtn.mouseX }} onClick={(e) => e.stopPropagation()}>
                {true && 
                <div
                  className="createproject-inner"
                  onMouseEnter={() => setHovered("project")}
                  onMouseLeave={() => setHovered(null)}
                  onClick={() => {
                    setCreateData({ styleNumber: data?.styleNumber });
                    setCreateModal(true);
                    setCreateProjectBtn(null);
                  }}
                >
                  {getIcon("CreateIcon", hovered === "project" ? "white" : "black")}
                  Create Project
                </div>
                }
                { hasAccessCreateModification && 
                <div
                  className="createproject-inner"
                  onMouseEnter={() => setHovered("modification")}
                  onMouseLeave={() => setHovered(null)}
                  onClick={() => {
                    let obj = {
                      styleNumber: data?.styleNumber,
                      Orgimg: data?.Orgimg,
                      imageUrl: data?.imageUrl,
                      category: data?.category || data?.categoryName || "",
                    };
                    setCreateData(obj);
                    setCreateModificationModal(true);
                  }}
                >
                  {getIcon("CreateModify", hovered === "modification" ? "white" : "black")}
                  Create Modification
                </div>
                }
                {hasAccessCreateCustomerQuote && 
                <div
                  className="createproject-inner"
                  onMouseEnter={() => setHovered("customer")}
                  onMouseLeave={() => setHovered(null)}
                  onClick={() => {
                    setActionType("customer");
                    setStockOrderModal(true);
                    setCreateProjectBtn(null);
                  }}
                >
                  <ConsistentIcon type="Vision_Project_Icon" color={hovered === "customer" ? "white" : "black"} />
                  {/* {getIcon("Vision_Project_Icon", hovered === "customer" ? "white" : "black")} */}
                  Create Customer Quote
                </div>
                }
                {hasAccessCreateStockQuote && 
                <div
                  className="createproject-inner"
                  onMouseEnter={() => setHovered("stock")}
                  onMouseLeave={() => setHovered(null)}
                  onClick={() => {
                    setActionType("stock");
                    setStockOrderModal(true);
                    setCreateProjectBtn(null);
                  }}
                >
                  <ConsistentIcon type="Vision_Project_Icon" color={hovered === "stock" ? "white" : "black"} />
                  {/* {getIcon("Vision_Project_Icon", hovered === "stock" ? "white" : "black")} */}
                  Create Stock Quote
                </div>
                }
                {hasAccessSetReStockQuote && 
                <div
                  className="createproject-inner"
                  onMouseEnter={() => setHovered("reorder")}
                  onMouseLeave={() => setHovered(null)}
                  onClick={() => {
                    setActionType("reorder");
                    setStockOrderModal(true);
                    setReOrderModal(false);
                    setCreateProjectBtn(null);
                  }}
                >
                  <ConsistentIcon type="Vision_Project_Icon" color={hovered === "reorder" ? "white" : "black"} />
                  {/* {getIcon("Vision_Project_Icon", hovered === "reorder" ? "white" : "black")} */}
                  Set Re-Stock Quote
                </div>
                }
                {hasAccessHideDesign && 
                <div
                  className="createproject-inner"
                  onMouseEnter={() => setHovered("Hide")}
                  onMouseLeave={() => setHovered(null)}
                  onClick={async () => {
                    try {
                      const newStatus = !isHidden;

                      await apiClient.post("/api/v1/styles/hideStyle", {
                        styleNumber: data?.styleNumber,
                        hideStatus: newStatus,
                      });

                      setIsHidden(newStatus);

                      queryClient.invalidateQueries(["styles"]);
                      queryClient.refetchQueries({ queryKey: ["styles"] });
                    } catch (error) {
                      console.log("Error hiding style:", error);
                    }
                  }}
                >
                  {" "}
                  <ConsistentIcon type="Hide" color={hovered === "Hide" ? "white" : "black"} /> {data?.isHidden ? "Unhide Design" : "Hide Design"}{" "}
                </div>
                }
              </div>
            </div>
          )}
        </Box>
      </Card>
      <ImageModal
        open={imageModal.isOpen}
        handleClose={handleCloseImageModal}
        data={imageModal}
        hasAccessToSeeWatermark={hasAccessToSeeWatermark}
        nextClick={() => handleNextClick()}
        prevClick={() => handlePrevClick()}
        hasNext={!isLastItem}
        hasPrev={!isFirstItem}
        selectedCartProducts={allData?.[currentIndex] ?? null}
        setQty={setQty}
        qty={qty}
        anchor={imageModalAnchor}
      />
      <BinnysSelectTableModal open={binnysSelectOrderModal} setOpen={setBinnysSelectOrderModal} styleNumber={`${data?.styleNumber}`} />
      <CreateProjectDetailsModal open={createModal} handleClose={handleCloseCreateModal} designData={createData} actionType={actionType} />
      <CreateStockOrderModal open={stockOrderModal} handleClose={() => setStockOrderModal(false)} designData={data} actionType={actionType} sourceType="productcard" />
      <ReOrderSettingsModal open={reOrderModal} handleClose={() => setReOrderModal(false)} designData={data} actionType={actionType} />
      <QuickCustomerOrder open={customerOrderModal} handleClose={() => setCustomerOrderModal(false)} designData={data} actionType={actionType} />
      <CreateModificationModal open={createModificationModal} handleClose={handleCloseCreateModificationModal} designData={createData} />
    </>
  );
};

export default React.memo(ProductCard);
